/**
 * Rutas a las que mandar a quien tiene el expediente incompleto.
 *
 * NO se usa `onboarding.next_action.href` del BE, que hoy emite
 * `/onboarding/kyc` y `/onboarding/esign`. Ninguna de las dos está declarada en
 * el router: caen en el catch-all de `/onboarding` (`identity-routes.tsx`), que
 * hace `<Navigate to="." />`. Dentro de una ruta splat, y con
 * `v7_relativeSplatPath` apagado como está aquí, ese `.` resuelve a la propia
 * URL — o sea, redirige a sí misma. El usuario NO ve un 404: ve el shell del
 * onboarding sin ningún paso dentro, que es peor porque no dice nada.
 *
 * Las de abajo están verificadas contra `identity-routes.tsx` y
 * `wallet-routes.tsx`. Persona física y moral tienen flujos distintos, y el
 * `href` único del BE no puede distinguirlos:
 *
 *   PF  identidad → /kyc/ine-capture                contratos → /onboarding/contract
 *   PM  identidad → /onboarding (next_step)       contratos → /onboarding/contracts
 *
 * Ojo con el singular y el plural: `contract` es el paso de persona física y
 * `contracts` la página de persona moral. Son componentes distintos, no un
 * dedazo.
 *
 * Cuando el BE emita rutas reales, esto se puede reemplazar por `href`.
 */
export interface OnboardingTaskRoutes {
  kyc: string;
  contracts: string;
}

const PF: OnboardingTaskRoutes = {
  kyc: '/kyc/ine-capture',
  contracts: '/onboarding/contract',
};

const PM: OnboardingTaskRoutes = {
  // RFC 0030 §12.4: la identidad del representante entra por /onboarding para
  // que `next_step` del BE decida (consentimiento → permisos → INE → selfie).
  // Un deep-link a la captura de INE saltaba `location_and_camera_admin` y
  // el engine rechazaba la captura con 422.
  kyc: '/onboarding',
  // Lo mismo para los contratos: `/onboarding/contracts` antes de que `closing`
  // esté desbloqueado responde 422 VAL-002 (la firma exige expediente y
  // revisión legal completos). La entrada aterriza en el paso pendiente.
  contracts: '/onboarding',
};

export function onboardingTaskRoutes(isPm: boolean): OnboardingTaskRoutes {
  return isPm ? PM : PF;
}
